import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import cn from '../../../utils/cn';
import Portal from '../../../atoms/Portal';

const Tooltip = TooltipPrimitive.Root;

const TooltipProvider = TooltipPrimitive.TooltipProvider;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
    arrow?: boolean;
  }
>(function TooltipContent(
  { className, align = 'center', sideOffset = 4, arrow = true, children, ...props },
  ref,
) {
  return (
    <Portal>
      <TooltipPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'z-1050 w-80 rounded-2xl bg-white p-5 text-neutral-700 shadow-xl outline-none ring-1 ring-neutral-300 data-[state=delayed-open]:animate-in data-[state=instant-open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=delayed-open]:fade-in-0 data-[state=instant-open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=delayed-open]:zoom-in-95 data-[state=instant-open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          className,
        )}
        {...props}
      >
        {children}

        {arrow && (
          <TooltipPrimitive.Arrow asChild>
            <svg width={10} height={5} viewBox="0 0 10 5" preserveAspectRatio="none">
              {/* Main triangle fill */}
              <path d="M0 0L5 5L10 0Z" fill="white" />

              {/* Left border */}
              <line
                x1="0"
                y1="0"
                x2="5"
                y2="5"
                className="stroke-neutral-300"
                strokeWidth="1"
              />

              {/* Right border */}
              <line
                x1="10"
                y1="0"
                x2="5"
                y2="5"
                className="stroke-neutral-300"
                strokeWidth="1"
              />
            </svg>
          </TooltipPrimitive.Arrow>
        )}
      </TooltipPrimitive.Content>
    </Portal>
  );
});

export { Tooltip, TooltipProvider, TooltipTrigger, TooltipContent };
